export default __webpack_public_path__ + "static/media/firasans-regular.ccd40ce2.woff";